import { AddCommerceSixthAndFinalStepLocationState, InfoBlockField } from '../../types/add_commerce.types';
import { integrationType as integrationTypeOptions } from '../../utils/data';

interface ProductsBlockProps {
  businessData: AddCommerceSixthAndFinalStepLocationState;
  terminalsUpdated: InfoBlockField[];
}

function FieldRow({ name, value }: InfoBlockField) {
  return (
    <div className="confirmation-info">
      <div className="info-fieldname">{name}</div>
      <div className="info semibold">{value ?? '-'}</div>
    </div>
  );
}

function InnerSeparator() {
  return <div className="products-inner-separator" />;
}

function ProductsBlock({ businessData, terminalsUpdated }: ProductsBlockProps) {
  const bd = businessData as any;
  const boolToSiNo = (value: any) => (value ? 'Sí' : 'No');
  const shippingAddress = bd.shippingAddress;
  const includesTips = bd.includesTips ?? bd.terminalPlan?.includesTips;
  const hasPosSale = bd.posSale === true || bd.posSale === 'true';
  const hasShippingAddressData = Boolean(
    shippingAddress?.addressStreet ||
    shippingAddress?.addressNumber ||
    shippingAddress?.addressFlatNumber ||
    shippingAddress?.neighborhood ||
    shippingAddress?.city?.name ||
    shippingAddress?.city ||
    shippingAddress?.city?.state?.name ||
    shippingAddress?.department,
  );
  const pickupAtGetnet = bd.shippingType === 'NAD' && !hasShippingAddressData;

  return (
    <div className="confirmation-card">
      <p className="confirmation-title">PRODUCTOS</p>

      <FieldRow name="Protección para ingresos (Zurich)" value={boolToSiNo(bd.insurances?.length > 0)} />

      <InnerSeparator />

      <FieldRow name="E-commerce" value={boolToSiNo(bd.ecommerce)} />
      {bd.ecommerce && (
        <>
          <FieldRow name="Pasarela de pago" value={bd.ecommerce?.processor ?? '-'} />
          <FieldRow
            name="Tipo de producto"
            value={
              Array.isArray(bd.ecommerce?.integrationTypes) && bd.ecommerce.integrationTypes.length > 0
                ? bd.ecommerce.integrationTypes
                    .map((it: any) => integrationTypeOptions.find((o) => o.value === it.id)?.name)
                    .filter(Boolean)
                    .join(', ')
                : '-'
            }
          />
        </>
      )}
      <FieldRow
        name="Centro comercial"
        value={boolToSiNo(bd.commercialCenter && bd.commercialCenter !== 'NO')}
      />
      <FieldRow name="Punto de venta" value={boolToSiNo(bd.integration != '0')} />

      <InnerSeparator />

      <FieldRow name="Facturación electrónica" value={boolToSiNo(bd.electronicInvoicing)} />
      {bd.electronicInvoicing && (
        <FieldRow
          name="Tipo de facturación"
          value={
            bd.electronicInvoicingType === 'GETNET_INTEGRATION'
              ? 'Integración Getnet(ePOS)'
              : bd.electronicInvoicingType === 'OTHER_INTEGRATION'
                ? 'Otra Integracion(ePOS)'
                : bd.electronicInvoicingType === 'NO_TERMINAL'
                  ? 'Sin terminal'
                  : '-'
          }
        />
      )}
      {bd.electronicInvoicing && bd.electronicInvoicingType === 'NO_TERMINAL' && (
        <FieldRow
          name="Tipo de plan"
          value={
            bd.planType === 'LITE'
              ? 'Plan Lite (Hasta 30 facturas mensuales)'
              : bd.planType === 'PREMIUM'
                ? 'Plan Premium (Hasta 100 facturas mensuales)'
                : '-'
          }
        />
      )}
      {bd.electronicInvoicing && (
        <FieldRow name="Solicitud de certificado Digital" value={boolToSiNo(bd.digitalCertificateRequest)} />
      )}

      <InnerSeparator />

      <FieldRow name="Venta de POS" value={boolToSiNo(hasPosSale)} />
      {hasPosSale &&
        terminalsUpdated
          .filter((field) => field.name !== 'Facturación electrónica')
          .map((field, index) => (
            <FieldRow key={index} name={`TERMINAL | ${field.name}`} value={field.value} />
          ))}
      {hasPosSale && (
        <>
          <FieldRow
            name="Forma de entrega"
            value={
              bd.shippingType === 'NAD'
                ? 'Getnet'
                : bd.shippingType === 'SALES_CHANNEL'
                  ? 'Canal de ventas'
                  : '-'
            }
          />
          <FieldRow name="Retirar producto en Getnet" value={boolToSiNo(pickupAtGetnet)} />
          {bd.shippingType !== 'SALES_CHANNEL' && !pickupAtGetnet && (
            <>
              <FieldRow
                name="Departamento"
                value={shippingAddress?.city?.state?.name ?? shippingAddress?.department ?? '-'}
              />
              <FieldRow
                name="Localidad"
                value={shippingAddress?.city?.name ?? shippingAddress?.city ?? '-'}
              />
              <FieldRow name="Barrio" value={shippingAddress?.neighborhood ?? '-'} />
              <FieldRow name="Dirección" value={shippingAddress?.addressStreet ?? '-'} />
              {shippingAddress?.addressFlatNumber && (
                <FieldRow name="Apto" value={shippingAddress.addressFlatNumber} />
              )}
              {shippingAddress?.addressSolar && (
                <FieldRow name="Solar" value={shippingAddress.addressSolar} />
              )}
              {shippingAddress?.addressPlot && (
                <FieldRow name="Manzana" value={shippingAddress.addressPlot} />
              )}
              <FieldRow name="Horario" value={shippingAddress?.schedule ?? '-'} />
              <FieldRow name="Teléfono" value={shippingAddress?.contactPhone ?? '-'} />
            </>
          )}
        </>
      )}

      <InnerSeparator />

      <FieldRow name="Propina" value={boolToSiNo(includesTips)} />
    </div>
  );
}

export default ProductsBlock;
